import { NgModule, Injector, APP_INITIALIZER, LOCALE_ID } from '@angular/core';
import { CommonModule, LOCATION_INITIALIZED, registerLocaleData } from '@angular/common';
import { TranslateModule, TranslateLoader, TranslateService, MissingTranslationHandler } from '@ngx-translate/core';
import { MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import localeHu from '@angular/common/locales/hu';
import { HttpBackend, HttpClient } from '@angular/common/http';
import { JwtHelperService, JwtModule } from '@auth0/angular-jwt';
import { LayoutComponent } from './layout/layout.component';
import { LoginComponent } from './login/login.component';
import { NavMenuComponent } from './nav-menu/nav-menu.component';
import { CoreRoutingModule } from './core-routing.module';
import { MaterialModule } from '@shared/public_api';
import { SharedModule } from '../shared/shared.module';
import { AuthGuardService } from '../shared/services/auth-guard.service';
import { AuthService } from '../shared/services/auth.service';
import { LanguageBottomSheetComponent } from './language-bottom-sheet/language-bottom-sheet.component';
import { SnackbarFactory } from '../shared/services/snackbar-factory';
import { LocationComponent } from './location/location.component';
import { CustomTranslateLoader } from '@app/shared/utils/custom-translate-loader';
import { MatIconModule } from '@angular/material/icon';
import { DateFnsModule, MAT_DATE_FNS_FORMATS } from '@angular/material-date-fns-adapter';
import { PasswordChangeComponent } from './nav-menu/password-change/password-change.component';
import { MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from 'src/environments/environment';
import { CaseInsensitiveMissingTranslationHandler } from '@app/shared/translate/CaseInsensitiveMissingTranslationHandler';
import { ForgotPasswordComponent } from './login/forgot-password/forgot-password.component';
import { ForgotPasswordConfirmationComponent } from './forgot-password/forgot-password-confirmation/forgot-password-confirmation.component';
import { ForgotPasswordChangeComponent } from './forgot-password/forgot-password-change/forgot-password-change.component';
import { PasswordStrengthComponent } from './forgot-password/password-strength/password-strength.component';
import { ForgotPasswordService } from '../shared/services/forgot-password.service';
import { AppVersionService } from '@app/shared/services/app-version.service';

export function createTranslateLoader(http: HttpBackend, injector: Injector) {

  return new CustomTranslateLoader(http, injector);
}

export function appInitializerFactory(
  translate: TranslateService,
  injector: Injector,
  appVersionService: AppVersionService
) {
  //appVersionService.getAppVersion()
  //  .subscribe({
  //    next: result => {
  //      localStorage.setItem("appVersionHash", result['bulkColumn'])
  //    }
  //  });
  return () =>
    new Promise<any>((resolve: any) => {
      const locationInitialized = injector.get(
        LOCATION_INITIALIZED,
        Promise.resolve(null)
      );
      locationInitialized.then(async () => {
        const langToSet = 'hu';
        translate.setDefaultLang('hu');
        translate.use(langToSet).subscribe({
          next: () => {},
          error: () => {
            console.error(
              `Problem with '${langToSet}' language initialization.'`
            );
          },
          complete: () => {
            resolve(null);
          }
        });
      });
    });
}
export function tokenGetter() {
  return localStorage.getItem('access_jwt');
}

registerLocaleData(localeHu, 'hu');

@NgModule({
  declarations: [
    LayoutComponent,
    LoginComponent,
    NavMenuComponent,
    LanguageBottomSheetComponent,
    LocationComponent,
    PasswordChangeComponent,
    ForgotPasswordComponent,
    ForgotPasswordConfirmationComponent,
    ForgotPasswordChangeComponent,
    PasswordStrengthComponent,
  ],
  exports: [LayoutComponent, LoginComponent, NavMenuComponent],
  imports: [
    CommonModule,
    CoreRoutingModule,
    SharedModule,
    MatIconModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    DateFnsModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient, Injector]

      },
      missingTranslationHandler: {provide: MissingTranslationHandler, useClass: CaseInsensitiveMissingTranslationHandler}

    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpBackend, Injector],
      },
      missingTranslationHandler: { provide: MissingTranslationHandler, useClass: CaseInsensitiveMissingTranslationHandler }
    }),
    JwtModule.forRoot({
      config: {
        tokenGetter,
      },
    }),
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFactory,
      deps: [TranslateService, Injector, AppVersionService],
      multi: true,
    },
    { provide: MAT_DATE_LOCALE, useValue: 'hu' },
    { provide: LOCALE_ID, useValue: 'hu' },
    { provide: MAT_DATE_FORMATS, useValue: MAT_DATE_FNS_FORMATS },
    AuthService,
    AuthGuardService,
    JwtHelperService,
    SnackbarFactory,
    ForgotPasswordService,
  ],
})
export class CoreModule {}
